(ns common.specs.provider
  (:require [clojure.spec.alpha :as s]
            [common.specs.universal]))

(s/def :provider/color string?)
(s/def :provider/data-type string?)
(s/def :provider/logo string?)
(s/def :provider/name string?)

(s/def ::provider
  (s/keys :req-un [:provider/color
                   :provider/data-type
                   :provider/logo
                   :provider/name
                   :common/uuid]))
